import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  selectAppStateLoggedInUser,
  selectAppStateApiUrl,
} from 'reducers/appState_selector';
import {
  selectChannels,
  selectNoteChannel,
  selectGeckoChannel,
} from 'reducers/channels_selector';
import ReplyBox from '../ReplyBox';
import { RBWfuncs, RBWdrafts } from './modules';
import { GeckoToastService } from 'ui';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { EditorState } from 'draft-js';
import {
  buildContactGroup,
  buildAgentGroup,
  buildSelectedChannelGroup,
  buildLastMessageChannelGroup,
} from 'services/template-tags';
import { CONSTS } from 'constants/index.js';
import GeckoFeatures from 'services/gecko-features';
import { renderError } from 'services/gecko-error';
const loadingRing = `${process.env.PUBLIC_URL}/img/loading_ring.svg`;

class ReplyBoxWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableChannels: [],
      editorMode: CONSTS.EDITOR_MODE_TYPE.RICH,
      editorState: EditorState.createEmpty(),
      noteMode: {
        on: false,
      },
      recipientChannel: {},
      botSuggestions: [],
    };
    const _this = this; // Need to keep this state for these callbacks
    this.updateCallbacks = {
      editorState: (editorState) => {
        const newState = { ..._this.state };
        newState.editorState = editorState;
        return _this.setState(newState);
      },
    };
  }

  UNSAFE_componentWillMount() {
    this.setState(RBWfuncs.state(this.props));
  }

  componentDidMount() {
    return this.getBotSuggestions();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.conversationId &&
      nextProps.conversationId !== this.props.conversationId
    ) {
      return this.setState(RBWfuncs.state(nextProps));
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.conversationId &&
      prevProps.conversationId !== this.props.conversationId
    ) {
      RBWdrafts.saveDrafts(prevProps, prevState);
      return this.getBotSuggestions();
    }
    if (prevProps.messages.length !== this.props.messages.length) {
      return this.getBotSuggestions();
    }
  }

  componentWillUnmount() {
    RBWdrafts.saveDrafts(this.props, this.state);
  }

  assignIfAppropriate(message) {
    let assigned = false;
    if (RBWfuncs.shouldAssign(this.props, message)) {
      this.props.updateAssignedConversationState(this.props.conversationId);
      assigned = true;
    }
    return assigned;
  }
  getLastStudentMessage = (messages) => {
    const notInternalMessages = (message) => {
      return (
        message?.sender_channel?.type !== 'conversation_event' &&
        message?.sender_channel?.type !== 'internal_note' &&
        message?.sender_channel?.type !== 'system_information' &&
        message?.sender_channel?.type !== 'form_response'
      );
    };
    const filteredMessages = messages.filter((message) =>
      notInternalMessages(message)
    );
    const lastMessage = filteredMessages[filteredMessages?.length - 1];
    const isGeckoChat = lastMessage?.sender_channel.type === 'gecko_chat';
    return !isGeckoChat ? lastMessage : null;
  };
  getBotSuggestions = async () => {
    if (
      !GeckoFeatures.can('chat-bot') ||
      !GeckoFeatures.can('bot-suggestions')
    ) {
      return;
    }
    const { messages } = this.props;
    const lastUserMessage = this.getLastStudentMessage(messages);
    const botId =
      lastUserMessage?.sender_channel.configuration?.use_bot_for_suggestions;

    if (lastUserMessage && lastUserMessage.content && botId) {
      const botSuggestions = await GeckoRequest.get(
        `/bots/${botId}/suggest-answer/${lastUserMessage.id}`
      );
      return this.setState({ botSuggestions: botSuggestions });
    }
    return this.setState({ botSuggestions: [] });
  };
  getAiSuggestion = async () => {
    const { messages } = this.props;
    const notStudentMessages = (message) => {
      return (
        message?.sender_channel?.type !== 'conversation_event' &&
        message?.sender_channel?.type !== 'internal_note' &&
        message?.sender_channel?.type !== 'system_information' &&
        message?.sender_channel?.type !== 'form_response' &&
        message?.sender_channel?.type !== 'gecko_chat'
      );
    };
    const filteredMessages = messages.filter((message) =>
      notStudentMessages(message)
    );
    const lastStudentMessage = filteredMessages[filteredMessages?.length - 1];
    const messageId = lastStudentMessage?.id;
    const channelId = lastStudentMessage?.sender_channel?.id;
    try {
      if (channelId) {
        const { suggestion } = await GeckoRequest.get(
          `/channel/${channelId}/ai-suggested-answer/${messageId}`
        );
        return suggestion;
      }
      return '';
    } catch (error) {
      renderError(error);
    }
  };

  exportConversation() {
    GeckoRequest.post('/user/get_otp').then(({ otp }) => {
      window.location = `${this.props.apiUrl}/conversation/export?otp=${otp}&conversation=${this.props.conversationId}`;
    });
  }

  getMetaProps() {
    const isAiSuggestionsEnabled =
      this.state.recipientChannel?.configuration?.ai_suggestions;
    return {
      noteMode: this.state.noteMode,
      notes: {
        show: true,
        onClick: () => {
          this.setState({ noteMode: { on: !this.state.noteMode.on } });
        },
      },
      attachments: {
        show: true,
      },
      downloads: {
        show: true,
        onClick: this.exportConversation.bind(this),
      },
      saved_replies: {
        show: true,
      },
      emoji: {
        show: true,
      },
      mail_merge: {
        show: true,
      },
      send: {
        show: true,
      },
      mail_forward: {
        show: true,
      },
      mail_cc: {
        show: this.state.recipientChannel?.type === 'mailgun',
      },
      exclude_signature: {
        show: this.state.recipientChannel?.type === 'mailgun',
      },
      ai_suggestion: {
        show:
          this.state.recipientChannel?.type === 'live_chat' &&
          isAiSuggestionsEnabled,
      },
    };
  }

  templateContext() {
    return [
      buildContactGroup(this.props.contact),
      buildAgentGroup(this.props.agent),
      buildSelectedChannelGroup({
        channel: this.state.recipientChannel,
        showChannelQueuePosition: false,
      }),
      buildLastMessageChannelGroup(this.state.availableChannels[0]),
    ];
  }

  onSetRecipientChannelId = (id) => {
    const availableChannels = RBWfuncs.getAvailableChannels(this.props);
    const channel = availableChannels.find(
      (channel) => Number(channel.id) === Number(id)
    );
    // Sets Recipient Channel and
    // updates the editor Mode to be appropriate for new channel selected.
    this.setState({
      recipientChannel: channel,
      editorMode: RBWfuncs.getEditorMode(channel.type),
    });
  };

  sendMessage(replyBoxSubmission) {
    const message = RBWfuncs.createMessage(this.props, replyBoxSubmission);
    const redirect = this.assignIfAppropriate(message);
    this.props.updateMessagesState(
      RBWfuncs.createTempMessage(this.props, message)
    );
    return GeckoRequest.post(
      `/conversation/${RBWfuncs.createPath(this.props, message)}`,
      message
    )
      .then(() => {
        RBWdrafts.clearDrafts(this.props);
        if (redirect) {
          new GeckoToastService().success(
            'Conversation has been assigned to you'
          );
          return GeckoLocation.goTo(
            `/conversations/${this.props.conversationId}`,
            { filter: CONSTS.FILTER_MY_CONVERSATIONS }
          );
        }
      })
      .catch(() => {
        new GeckoToastService().error(
          'Message failed to send, make sure you have a network connection and try again.'
        );
        return;
      });
  }

  render() {
    const availableChannels = RBWfuncs.getAvailableChannels(this.props);
    const lastMessageChannel = this.props.channels.find((channel) => {
      return Number(channel.id) === Number(this.props.lastMessageChannel);
    });
    return (
      <ReplyBox
        showChannelSelector={true}
        lastMessageChannel={lastMessageChannel}
        autoFocus={true}
        availableChannels={availableChannels}
        exportHandler={this.exportConversation.bind(this)}
        editorMode={this.state.editorMode}
        editorState={this.state.editorState}
        handleSubmission={this.sendMessage.bind(this)}
        meta={this.getMetaProps()}
        noteMode={this.state.noteMode}
        recipientChannel={this.state.recipientChannel}
        recipientChannelId={
          this.state.recipientChannel && this.state.recipientChannel.id
        }
        onRecipientChannelIdSelected={(id) => this.onSetRecipientChannelId(id)}
        agent={this.props.agent}
        templateContext={this.templateContext()}
        toolbarClassName={'conversations-toolbar'}
        contact={this.props.contact}
        updateCallbacks={this.updateCallbacks}
        conversationId={this.props.conversationId}
        cc={this.props.conversationCC}
        bcc={this.props.conversationBCC}
        updateCC={this.props.updateCC}
        updateBCC={this.props.updateBCC}
        onForward={this.props.onForward}
        botSuggestions={this.state.botSuggestions}
        handleAiSuggestion={this.getAiSuggestion}
      />
    );
  }
}

ReplyBoxWrapper.propTypes = {
  channels: PropTypes.array,
  contact: PropTypes.object,
  conversationAgentIds: PropTypes.array,
  conversationId: PropTypes.number,
  currentFilter: PropTypes.string,
  messages: PropTypes.array,
  scrollToBottom: PropTypes.func,
  updateAssignedConversationState: PropTypes.func,
  updateMessagesState: PropTypes.func,
};

ReplyBoxWrapper.defaultProps = {
  contact: {
    additional: {
      profile_picture_url: loadingRing,
    },
    custom_fields: {},
    external_ids: {},
    placeholder: true,
  },
  messages: [],
};

const mapStateToProps = (state, props) => {
  return {
    agent: selectAppStateLoggedInUser(state),
    apiUrl: selectAppStateApiUrl(state),
    channels: selectChannels(state).filter((channel) => !channel.deletedAt),
    geckoChannel: selectGeckoChannel(state),
    noteChannel: selectNoteChannel(state),
    lastMessageChannel:
      state.conversationsRoute.conversationById[props.conversationId] &&
      state.conversationsRoute.conversationById[props.conversationId]
        .last_message_channel,
  };
};

export default connect(mapStateToProps)(ReplyBoxWrapper);
